/**
 * Sort two objects by the given list of properties, in ascending order
 */
const sortByProperty = (a: any, b: any, properties: any): any => {
  if (properties.length === 0) return 0;

  let ap = a[properties[0]];
  let bp = b[properties[0]];

  // ignore upper and lowercase
  if (typeof ap === 'string') ap = ap.toUpperCase();
  if (typeof bp === 'string') bp = bp.toUpperCase();

  if (ap === undefined && bp === undefined)
    return sortByProperty(a, b, properties.slice(1));

  if (ap === undefined || ap > bp) {
    return 1;
  } else if (bp === undefined || ap < bp) {
    return -1;
  } else {
    return sortByProperty(a, b, properties.slice(1));
  }
};

/**
 * Return a sort function that sorts by an ordered list of properties, in ascending order
 */
const sortBy = (propertyList: any) => (a: any, b: any): any =>
  sortByProperty(a, b, propertyList);

export default sortBy;
